// Locale routing configuration and helpers.
export const SUPPORTED_LOCALES = ["en", "es"];
export const DEFAULT_LOCALE = "en";

// Detect preferred locale: stored preference -> browser language -> default.
export function detectLocale() {
  try {
    const stored = localStorage.getItem("astro_lang");
    if (SUPPORTED_LOCALES.includes(stored)) return stored;
  } catch (e) { /* ignore */ }
  const nav = (typeof navigator !== "undefined" && (navigator.language || "en")).slice(0, 2).toLowerCase();
  return SUPPORTED_LOCALES.includes(nav) ? nav : DEFAULT_LOCALE;
}

// Current locale from the URL path (source of truth for links).
export function currentLocale() {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  const seg = window.location.pathname.split("/")[1];
  return SUPPORTED_LOCALES.includes(seg) ? seg : DEFAULT_LOCALE;
}

// Prefix an internal absolute path with a locale (leaving admin/external/localized paths untouched).
export function localizePath(to, locale) {
  if (typeof to !== "string") return to;
  if (!to.startsWith("/")) return to;
  if (to.startsWith("/admin")) return to;
  const seg = to.split("/")[1];
  if (SUPPORTED_LOCALES.includes(seg)) return to;
  return `/${locale}${to === "/" ? "" : to}`;
}

// Swap the locale segment of the current path (for the language switcher).
export function swapLocale(pathname, newLocale) {
  const parts = pathname.split("/");
  if (SUPPORTED_LOCALES.includes(parts[1])) {
    parts[1] = newLocale;
    return parts.join("/") || `/${newLocale}`;
  }
  return `/${newLocale}${pathname === "/" ? "" : pathname}`;
}
